import { getTnC } from 'api/main/tnc'
import React, { useState } from 'react'
import { useQuery } from 'react-query'
import {useNavigate, useLocation} from 'react-router-dom'

const initialModal = { open: false, code: '' }
const useTnC = () => {
   const navigate = useNavigate();
   const location = useLocation();
   const [modal, setModal] = useState({ ...initialModal })
   function openModal(code) {
      setModal((prev) => ({ ...prev, open: true, code: code }))
   }
   function closeModal() {
      setModal({ ...initialModal })
      const path = location.pathname;
      if (path.includes("/terms-and-conditions") || path.includes("/privacy-policy")) {
         navigate("/", { replace: true });
      }
   }
   const getTnCQuery = useQuery({
      queryKey: 'getTnCQuery',
      queryFn: () => getTnC(modal?.code),
      onError: () => {},
      enabled: !!modal.code && modal.open
   })
   return {
      modal,
      openModal,
      closeModal,
      tcContent: getTnCQuery?.data?.data?.content || '',
      isFetchingTnC: getTnCQuery.isLoading
   }
}

export default useTnC
